<!-- Contacts model -->
<div class="modal-header">
    <h5 class="modal-title">Modifier un Objectif spécifique</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-3">
    <div class="text-left">
        <form>

            <!-- Première ligne -->
            <div class="row mb-3">
                  <div class="form-group col-md-12">
                    <label for="montant">Programme</label>
                     <select
                          name="programme_id"
                          id="programme_id"
                          (change)="onSelectProgramme()"
                          [(ngModel)]="item.programme_id"
                          class="form-select"
                        >
                      <option value=""></option>
                      <option *ngFor="let prog of programmeData" [ngValue]="prog">
                        {{ prog.libelle }}
                      </option>
                    </select>
                </div>
            </div>

            <div class="row">
                  <div class="form-group col-md-3">
                    <label for="code">Code</label>
                    <input [(ngModel)]="item.code" name="code" type="text" class="form-control" id="code">
                </div>
                <div class="form-group col-md-9">
                    <label for="libelle">Libellé</label>
                    <input [(ngModel)]="item.libelle" name="libelle" type="text" class="form-control" id="libelle">
                </div>
            </div>


            <div class="text-end mt-3">
                <button (click)="close()" type="button" class="btn btn-light ms-1">
                    <i class="pi pi-times" style="color: #212529"></i> Annuler
                </button>&nbsp;
                <button (click)="editObejectif()" type="submit" class="btn btn-success">
                    <i class="pi pi-save" style="color: white"></i> Enregistrer
                </button>
            </div>

        </form>
    </div>
</div>
